'use strict';

const Common = [
    ["te", "alwBlk", "isDis", "isRead", "isHdn", "isLbl", "isLabel", "nowrap"],
    ["c", "cId", "lblAlg"],
    ["desId", "lblW", "ctlW", "ctlH"]];
const Common_cm = [
    ["te", "alwBlk", "isDis", "isRead", "isHdn", "isLbl", "isLabel", "nowrap"],
    ["c_mult", "cId", "lblAlg"],
    ["desId", "lblW", "ctlW", "ctlH"]];

const EditorTypes = {
    // 通用描述
    Common: Common,
    // 文本控件
    Dnd_SgiFormTextEditor: [
        ...Common,
        ["vldC", "defVal10", "bdText"],
        ["minL", "maxL", "isPwd"],
        ["minV", "maxV"],
        ["inpPopTe"]
    ],
    // 数字控件
    Dnd_SgiFormNumberEditor: [
        ...Common,
        ["minV", "maxV", "step"],
        ["minL", "maxL", "dcmDgt"],
        ["inpPopTe", "selectType"]
    ],
    // 文本域控件
    Dnd_SgiFormTextAreaEditor: [
        ...Common,
        ["minL", "maxL", "ctlRow"],
        ["inpPopTe", "isScl"]
    ],
    // 日期控件
    Dnd_SgiFormDateEditor: [
        ...Common_cm,
        ["dateFmt", "optBDt", "optEDt"],
        ["ctlMode", "inpPopTe"]
    ],
    // 时间控件
    Dnd_SgiFormTimeEditor: [
        ...Common,
        ["hourStep", "minuteStep", "secondStep"],
        ["inpPopTe", "timeFmt"]
    ],
    // 文件控件
    Dnd_SgiFormFileEditor: [
        ...Common,
        ["btnN", "cluW", "iconPh"],
        ["disType", "mulSel", "isHdnLst", "isDrag", "isBttn", "hdUpld"],
        ["accept", "nLimit"],
        ["action"]
    ],
    // 下拉窗控件
    Dnd_SgiFormComboboxEditor: [
        ...Common,
        ["scId", "shows"],
        ["inpPopTe", "mulSel", "autoSel", "search"],
        ["emptyText", "allowClear", "numLimit"]
    ],
    // 复选框控件
    Dnd_SgiFormCheckboxEditor: [
        ...Common,
        ["defVal10", "escape"]
    ],
    // 复选框组件
    Dnd_SgiFormCheckboxGroupEditor: [
        ...Common,
        ["scId", "shows"],
        ["checked"],
        ["browserWidth", "occupiedBig", "occupiedSmall",]
    ],
    // tag
    Dnd_SgiTagEditor: [
        ["te", "isLbl", "scId"],
        ["c", "cId",],
        ["desId", "lblW", "ctlW", "ctlH"],
        ["occupied", "astrict"]
    ],
    // 单选框组件
    Dnd_SgiFormRadioEditor: [
        ...Common,
        ["scId", "shows"],
        ["checked"],
    ],
    // 弹出窗控件
    Dnd_SgiFormPopUIEditor: [
        ...Common,
        ["minL", "maxL"],
        ["isCustom", "uid"],
        ["inpPopTe"]
    ],
    // 富文本控件
    Dnd_SgiFormEditorEditor: [
        ...Common,
        ["fileUploadUrl", "toolbarHidden"]
    ],
    // 下拉树控件
    Dnd_SgiFormComboxTreeEditor: [
        ...Common,
        ["scId", "insName", "mulSel"],
        ["showKey", "saveKey"],
        ["inpPopTe"]
    ],
    // 级联控件
    Dnd_SgiFormCascaderEditor: [
        ...Common_cm,
        ["scId", "checked"]
    ],
    // codemirror
    Dnd_SgiFormCodeMirrorEditor: [
        ...Common,
        // ["scId", "checked"]
    ]
};

const EditorDesc = {
    // 通用描述
    Common: [[
        { code: "te", span: 8 },
        { code: "alwBlk", span: 3 },
        { code: "isDis", span: 3 },
        { code: "isRead", span: 3 },
        { code: "isHdn", span: 3 },
        { code: "isLbl", span: 3 }
    ], [
        { code: "c", span: 8 },
        { code: "cId", span: 8 },
        { code: "lblAlg", span: 8 }
    ], [
        { code: "lblW", span: 8 },
        { code: "ctlW", span: 8 },
        { code: "ctlH", span: 8 }
    ]],
    // 日期组件
    Dnd_SgiFormDateEditor: [[
        { code: "te", span: 8 },
        { code: "alwBlk", span: 3 },
        { code: "isDis", span: 3 },
        { code: "isRead", span: 3 },
        { code: "isHdn", span: 3 },
        { code: "isLbl", span: 3 }
    ], [
        { code: "c_mult", span: 8 },
        { code: "cId", span: 8 },
        { code: "lblAlg", span: 8 }
    ], [
        { code: "lblW", span: 8 },
        { code: "ctlW", span: 8 },
        { code: "ctlH", span: 8 }
    ]],
    // 级联组件
    Dnd_SgiFormCascaderEditor: [[
        { code: "te", span: 8 },
        { code: "alwBlk", span: 3 },
        { code: "isDis", span: 3 },
        { code: "isRead", span: 3 },
        { code: "isHdn", span: 3 },
        { code: "isLbl", span: 3 }
    ], [
        { code: "c_mult", span: 8 },
        { code: "cId", span: 8 },
        { code: "lblAlg", span: 8 }
    ], [
        { code: "lblW", span: 8 },
        { code: "ctlW", span: 8 },
        { code: "ctlH", span: 8 }
    ]],
    // 文本控件
    Dnd_SgiFormTextEditor: [[
        { code: "te", span: 8 },
        { code: "alwBlk", span: 3 },
        { code: "isDis", span: 3 },
        { code: "isRead", span: 3 },
        { code: "isHdn", span: 3 },
        { code: "isLbl", span: 3 }
    ], [
        { code: "c", span: 8 },
        { code: "cId", span: 8 },
        { code: "lblAlg", span: 8 }
    ], [
        { code: "lblW", span: 8 },
        { code: "ctlW", span: 8 },
        { code: "ctlH", span: 8 }
    ], [
        { code: "vldC", span: 8 },
        { code: "defVal10", span: 8 },
        { code: "bdText", span: 8 }
    ], [
        { code: "minL", span: 8 },
        { code: "maxL", span: 8 }
    ], [
        { code: "inpPopTe", span: 16 }
    ]]
};


export { EditorTypes, EditorDesc };
export default { EditorTypes, EditorDesc };


// WEBPACK FOOTER //
// ./~/rt-sd-dnd/sgiDndDev/Dnd_SgiFormEditorCommonConstants.js